import React, { useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import { ArrowRight, Lock, CheckCircle } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import ProntoLogo from "@/components/ProntoLogo";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error("Almeno 8 caratteri");
    if (password !== confirm) return toast.error("Le password non coincidono");
    setLoading(true);
    try {
      await api.post("/auth/password-reset/confirm", { token, new_password: password });
      setDone(true);
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Errore nel reset");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center p-6">
        <div className="max-w-md text-center">
          <h1 className="font-editorial text-3xl">Link non valido</h1>
          <p className="mt-3 text-[#6B6A65]">Il link di reset è mancante o scaduto.</p>
          <Link to="/forgot-password" className="btn-primary mt-6 inline-flex" data-testid="request-new-link">
            Richiedi un nuovo link
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-6">
      <div className="max-w-md w-full">
        <Link to="/" className="inline-block mb-10">
          <img src="/logo/mark-symbol.png?v=8" alt="Pronto" className="h-12 w-12 select-none" draggable="false" />
        </Link>
        {!done ? (
          <>
            <h1 className="font-editorial text-4xl tracking-tight text-[#1C1C1A]" data-testid="reset-password-title">
              Scegli una<br/>
              <span className="italic-accent text-[#7C8B6E]">nuova password.</span>
            </h1>
            <p className="mt-4 text-[#6B6A65]">
              Minimo 8 caratteri. Meglio se con lettere + numeri.
            </p>
            <form onSubmit={submit} className="mt-8 space-y-4" data-testid="reset-password-form">
              <label className="block">
                <span className="text-xs uppercase tracking-[0.18em] text-[#6B6A65]">Nuova password</span>
                <input
                  type="password"
                  required
                  minLength={8}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="mt-2 w-full px-4 py-3 border border-[#E5E7E0] focus:border-[#7C8B6E] outline-none"
                  placeholder="••••••••"
                  data-testid="reset-password-new"
                />
              </label>
              <label className="block">
                <span className="text-xs uppercase tracking-[0.18em] text-[#6B6A65]">Conferma password</span>
                <input
                  type="password"
                  required
                  minLength={8}
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  className="mt-2 w-full px-4 py-3 border border-[#E5E7E0] focus:border-[#7C8B6E] outline-none"
                  placeholder="••••••••"
                  data-testid="reset-password-confirm"
                />
              </label>
              <button
                type="submit"
                disabled={loading}
                className="btn-primary w-full justify-center"
                data-testid="reset-password-submit"
              >
                {loading ? "Aggiornamento..." : <>Aggiorna password <ArrowRight size={18} weight="bold" /></>}
              </button>
            </form>
          </>
        ) : (
          <div className="text-center" data-testid="reset-password-done">
            <div className="w-16 h-16 rounded-full bg-[#F1F4ED] flex items-center justify-center mx-auto mb-6">
              <CheckCircle size={32} weight="fill" className="text-[#7C8B6E]" />
            </div>
            <h1 className="font-editorial text-3xl">Fatto.</h1>
            <p className="mt-3 text-[#6B6A65]">La tua password è stata aggiornata. Ti stiamo portando al login…</p>
          </div>
        )}
      </div>
    </div>
  );
}
